<template>
  <div>
    <custom-light-card
      icon="mdi-map-marker"
      :specificTitleClasses="isPropertyOrdo ? 'success--text' : ''"
      :subtitle="item.propertyAdress"
      :title="item.property_shortname"
    />
    <custom-simple-table
      :item="item"
      i18-path="requests.fields"
      :specificClasses="propertyTableStyle"
      :table-keys="propertyTableKeys"
    />

    <div class="font-weight-bold my-2">
      {{ generateMessage('tech_search.property_interventions') }}
    </div>

    <loader :is-loading="isLoadingInProgressItvs">
      <v-simple-table
        dense
        class="background"
        v-if="inProgressPropertyItvs && inProgressPropertyItvs.length"
      >
        <tbody>
          <tr
            v-for="(intervention, index) in inProgressPropertyItvs"
            :key="index"
          >
            <td class="caption  pa-0 font-weight-bold">
              <intervention-date
                :date="intervention.event_datetime | transformDate"
                :status="intervention | getStatus"
              />
            </td>
            <td class="caption  px-2">
              {{ intervention.reference }}
            </td>
            <td class="caption  pa-0 text-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    {{
                      intervention.full_name.length > 11
                        ? intervention.full_name.slice(0, 11).concat('...')
                        : intervention.full_name
                    }}
                  </div>
                </template>
                <div class="text-center">
                  <div>{{ intervention.full_name }}</div>
                  <div>{{ intervention.phone }}</div>
                </div>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-else class="caption font-italic">
        {{ generateMessage('tech_search.no_data_in_progress') }}
      </div>
      <loader :is-loading="isLoadingScheduledItvs">
        <v-simple-table
          dense
          class="background"
          v-if="scheduledPropertyItvs && scheduledPropertyItvs.length"
        >
          <tbody>
            <tr
              v-for="(intervention, index) in scheduledPropertyItvs"
              :key="index"
            >
              <td class="caption  pa-0 font-weight-bold">
                <intervention-date
                  :date="intervention.event_datetime | transformDate"
                  :status="intervention | getStatus"
                />
              </td>
              <td class="caption  px-2">
                {{ intervention.reference }}
              </td>
              <td class="caption  pa-0 text-end">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      {{
                        intervention.full_name.length > 11
                          ? intervention.full_name.slice(0, 11).concat('...')
                          : intervention.full_name
                      }}
                    </div>
                  </template>
                  <div class="text-center">
                    <div>{{ intervention.full_name }}</div>
                    <div>{{ intervention.phone }}</div>
                  </div>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div v-else class="caption font-italic">
          {{ generateMessage('tech_search.no_data_scheduled') }}
        </div>
      </loader>
    </loader>
  </div>
</template>

<script>
import CustomLightCard from '@/components/cards/CustomLightCard';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { generateMessage } from '@/utils/i18n';
import {
  getInProgressItvsByPropertyId,
  getScheduledItvsByPropertyId,
} from '@/services/services/staffInterventions.service';
import getStatus, {
  transformDate,
} from '@/components/selects/technician/technicianStatus';
import InterventionDate from '@/components/displays/InterventionDate';
import Loader from '@/components/widgets/Loader';

export default {
  name: 'CustomPropertyDetails',
  components: {
    CustomLightCard,
    CustomSimpleTable,
    InterventionDate,
    Loader,
  },
  props: {
    isPropertyOrdo: { type: Boolean, required: false },
    item: { type: Object, required: true },
  },
  watch: {
    item(val) {
      if (val) {
        this.loadInProgressInterventions(val);
        this.loadScheduledInterventions(val);
      }
    },
  },
  mounted() {
    this.loadInProgressInterventions(this.item);
    this.loadScheduledInterventions(this.item);
  },
  computed: {
    propertyTableKeys() {
      return [this.item.property ? 'id' : 'request_id', 'property_code'];
    },
    propertyTableStyle() {
      const classes = [];
      if (this.isPropertyOrdo) {
        for (let index = 0; index < this.propertyTableKeys.length; index += 1) {
          classes.push(
            [
              this.propertyTableKeys.indexOf('property_code'),
              this.propertyTableKeys.indexOf('property_shortname'),
            ].includes(index)
              ? 'success--text'
              : ''
          );
        }
      }
      return classes;
    },
  },
  methods: {
    generateMessage,
    displayInfos(val) {
      this.$emit('display', val);
    },
    loadInProgressInterventions(val) {
      this.inProgressPropertyItvs = null;
      this.isLoadingInProgressItvs = true;
      getInProgressItvsByPropertyId(val.property_id)
        .then((data) => {
          this.inProgressPropertyItvs = data;
        })
        .finally(() => {
          this.isLoadingInProgressItvs = false;
        });
    },
    loadScheduledInterventions(val) {
      this.scheduledPropertyItvs = null;
      this.isLoadingScheduledItvs = true;
      getScheduledItvsByPropertyId(val.property_id)
        .then((data) => {
          this.scheduledPropertyItvs = data;
        })
        .finally(() => {
          this.isLoadingScheduledItvs = false;
        });
    },
  },
  filters: {
    transformDate,
    getStatus,
  },
  data: () => ({
    inProgressPropertyItvs: null,
    isLoadingInProgressItvs: false,
    isLoadingScheduledItvs: false,
    scheduledPropertyItvs: null,
  }),
};
</script>

<style scoped>
.no-hover-table {
  pointer-events: none;
}
</style>
